// import { Navigate } from "react-router-dom";
import Home from "../pages/Home";
import User from "../pages/User";
import About from "../pages/About";
import Products from "../pages/Products";
import Settings from "../pages/Settings";
import DataList from "../pages/DataList";

const routes = [
  // {
  //   path: "/",
  //   element: <Navigate to="/home" />,
  // },
  {
    path: "/",
    element: <Home />,
    name: "首页",
  },
  {
    path: "/user",
    element: <User />,
    name: "用户中心",
  },
  {
    path: "/about",
    element: <About />,
    name: "关于我们",
  },
  {
    path: "/products",
    element: <Products />,
    name: "产品管理",
  },
  {
    path: "/data",
    element: <DataList />,
    name: "数据列表",
  },
  {
    path: "/settings",
    element: <Settings />,
    name: "设置",
  },
];

export default routes;
